import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import InsightPanel from "./InsightPanel";
import { MdDragIndicator } from "react-icons/md";

const SortableMenuItem = ({ id, isInsight, insightConfig, onInsightChange, reportConfiguration, onReportConfigChange, isActive, onSelectPreview }) => {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });
    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        padding: "5px 10px",
        marginBottom: "8px",
        background: isActive ? "#eef2ff" : "#f5f5f5",
        borderRadius: "px",
        border: "1px solid #ddd",
        boxShadow: isActive ? "rgba(0, 0, 0, 0.24) 0px 3px 8px" : "none"
    };

    return (
        <div ref={setNodeRef} style={style}>
            <div className="d-flex align-items-center justify-content-between">
                <span
                    className="drag-handle"
                    {...attributes}
                    {...listeners}
                    style={{ cursor: "grab", marginRight: "8px" }}
                    title="Drag to reorder"
                >
                    <MdDragIndicator />
                </span>
                <span
                    className={`menu-item-title ${isActive ? "active" : ""}`}
                    style={{ cursor: "pointer", flex: 1 }}
                    onClick={() => onSelectPreview(id)}>
                    {id}
                </span>
            </div>
            {isInsight && (
                <div className="mt-2">
                    <InsightPanel
                        insightConfig={insightConfig}
                        onChange={onInsightChange}
                        reportConfiguration={reportConfiguration}
                        setReportConfiguration={onReportConfigChange}
                    />
                </div>
            )}
        </div>
    );
};

export default SortableMenuItem;